import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum, momentFormat } from "@/utils/utils";
import { ISCMAssetsEntryDetail } from "../assetsEntryTypes";
import { useAssetsEntryModel } from "../assetsEntryModel";
import { globalPrompt } from "@/components/message";
import useNavModel from "@/model/navModel";
import { useAssetsEntryDetailsModel } from "./details/assetsEntryDetailsModel";
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { useOrgModel } from '@/views/base/organization/orgModel'

export function DataTable() {
    const { getTreeNodeName } = useDictModel(() => []);
    const { getSelectedDictOne } = useDictModel(() => [])
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useAssetsEntryModel();
    const { resetEditCatch } = useAssetsEntryDetailsModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const { getOrgTreeSelect } = useOrgModel(() => []);

    useEffect(() => {
        loadData()
    }, [])
    const onLook = (value) => {

        let supplierEditKey = '2-1-2'
        let isFindNav = findNav(supplierEditKey)
        if (!isFindNav) {
            addNav(supplierEditKey, { id: value.id, mode: 'look' })
        } else {
            globalPrompt('modal', {
                title: '供应商跳转详情',
                type: 'warning',
                text: '您还有供应商详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: value.id, mode: 'look' })
                },
            })
        }
    }
    const columns: ColumnsType<ISCMAssetsEntryDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '采购单号',
            width: 150,
            dataIndex: 'code',
            render: (t, r) => (
                <span
                    style={{ color: '#4165E3', cursor: 'pointer' }}
                    onClick={() => { onLook(r) }}
                >
                    {t}
                </span>
            ),
        },
        {
            title: '供应商名称',
            width: 160,
            dataIndex: 'supplierName',
        },

        {
            title: '申请部门',
            width: 160,
            dataIndex: 'departmentName',
        },
        {
            title: '采购数量',
            width: 120,
            dataIndex: 'totalNum',
        },
        {
            title: '采购金额',
            width: 120,
            dataIndex: 'totalAmount',
        },

        {
            title: '采购员',
            width: 100,
            dataIndex: 'createUser',
        },
        {
            title: '采购时间',
            width: 150,
            dataIndex: 'createTime',
            render: (text) => `${momentFormat(text)}`
        },
        // {
        //     title: '采购说明',
        //     width: 150,
        //     dataIndex: 'note',
        // }, {
        //     title: '采购来源',
        //     width: 160,
        //     dataIndex: 'source',
        //     render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_SOURCE).find((item) => item.value === text)?.label ?? '',
        // }, {
        //     title: '发票类型',
        //     width: 120,
        //     dataIndex: 'invoiceTypeCode',
        //     render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_INVOICE_TYPE).find((item) => item.value === text)?.label ?? '',

        // },
        {
            title: '打印次数',
            width: 100,
            dataIndex: 'printingTimes',
        },
    ];

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: (total: number) => `共${total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            bordered
            scroll={{ x: 'max-content', y: "calc(100vh - 410px)" }}
        />
    )
}
